export const APPLICATION_ERMS=2;